import React from "react"

const Hero = () => {
  return (
    <section>
      <div className="bg-snow-100 flex items-center justify-center relative">
        <div className="mx-auto w-11/12 md:w-10/12 xl:w-8/12 text-center">
          <div className="h-32 w-full"></div>
          <h1
            className="text-grey-100 font-bold text-5xl w-10/12 mx-auto shortFadeIn"
            style={{ lineHeight: "62px" }}
          >
            People, technology and our passion to innovate
          </h1>
          <h2
            className="text-grey-200 tracking-xs text-lg mt-4 md:w-9/12 mx-auto shortFadeIn delay-300ms"
            style={{ letterSpacing: "0.01em" }}
          >
            Woodcore is the leading, most experienced, Platinum Value-Added Core
            Banking Application experts. Over five years of experience working
            on projects with multinationals before the African market.
          </h2>
          <div className="h-32 w-full"></div>
        </div>
      </div>
    </section>
  )
}

export default Hero
